/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MessageSchedulePutRequestGeometry } from './MessageSchedulePutRequestGeometry';
import {
    MessageSchedulePutRequestGeometryFromJSON,
    MessageSchedulePutRequestGeometryFromJSONTyped,
    MessageSchedulePutRequestGeometryToJSON,
} from './MessageSchedulePutRequestGeometry';
import type { ScheduleDetail } from './ScheduleDetail';
import {
    ScheduleDetailFromJSON,
    ScheduleDetailFromJSONTyped,
    ScheduleDetailToJSON,
} from './ScheduleDetail';

/**
 * 
 * @export
 * @interface Schedule
 */
export interface Schedule {
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    action?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Schedule
     */
    addressed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    areaStart?: string;
    /**
     * 
     * @type {number}
     * @memberof Schedule
     */
    broadcastInterval?: number;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    duration?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Schedule
     */
    enabled?: boolean;
    /**
     * 
     * @type {MessageSchedulePutRequestGeometry}
     * @memberof Schedule
     */
    geometry?: MessageSchedulePutRequestGeometry;
    /**
     * 
     * @type {Array<string>}
     * @memberof Schedule
     */
    groups?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof Schedule
     */
    linkageIds?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof Schedule
     */
    noticeDescription?: number;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    owner?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Schedule
     */
    routing?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Schedule
     */
    safety?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    schedMsgName?: string;
    /**
     * 
     * @type {Array<ScheduleDetail>}
     * @memberof Schedule
     */
    schedule?: Array<ScheduleDetail>;
    /**
     * 
     * @type {number}
     * @memberof Schedule
     */
    senderMmsi?: number;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    shapeuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof Schedule
     */
    uid?: string;
}

/**
 * Check if a given object implements the Schedule interface.
 */
export function instanceOfSchedule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ScheduleFromJSON(json: any): Schedule {
    return ScheduleFromJSONTyped(json, false);
}

export function ScheduleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Schedule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'action': !exists(json, 'action') ? undefined : json['action'],
        'addressed': !exists(json, 'addressed') ? undefined : json['addressed'],
        'areaStart': !exists(json, 'area_start') ? undefined : json['area_start'],
        'broadcastInterval': !exists(json, 'broadcast_interval') ? undefined : json['broadcast_interval'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'geometry': !exists(json, 'geometry') ? undefined : MessageSchedulePutRequestGeometryFromJSON(json['geometry']),
        'groups': !exists(json, 'groups') ? undefined : json['groups'],
        'linkageIds': !exists(json, 'linkage_ids') ? undefined : json['linkage_ids'],
        'noticeDescription': !exists(json, 'notice_description') ? undefined : json['notice_description'],
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'routing': !exists(json, 'routing') ? undefined : json['routing'],
        'safety': !exists(json, 'safety') ? undefined : json['safety'],
        'schedMsgName': !exists(json, 'sched_msg_name') ? undefined : json['sched_msg_name'],
        'schedule': !exists(json, 'schedule') ? undefined : ((json['schedule'] as Array<any>).map(ScheduleDetailFromJSON)),
        'senderMmsi': !exists(json, 'sender_mmsi') ? undefined : json['sender_mmsi'],
        'shapeuid': !exists(json, 'shapeuid') ? undefined : json['shapeuid'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
    };
}

export function ScheduleToJSON(value?: Schedule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'action': value.action,
        'addressed': value.addressed,
        'area_start': value.areaStart,
        'broadcast_interval': value.broadcastInterval,
        'description': value.description,
        'duration': value.duration,
        'enabled': value.enabled,
        'geometry': MessageSchedulePutRequestGeometryToJSON(value.geometry),
        'groups': value.groups,
        'linkage_ids': value.linkageIds,
        'notice_description': value.noticeDescription,
        'owner': value.owner,
        'routing': value.routing,
        'safety': value.safety,
        'sched_msg_name': value.schedMsgName,
        'schedule': value.schedule === undefined ? undefined : ((value.schedule as Array<any>).map(ScheduleDetailToJSON)),
        'sender_mmsi': value.senderMmsi,
        'shapeuid': value.shapeuid,
        'status': value.status,
        'text': value.text,
        'type': value.type,
        'uid': value.uid,
    };
}

